import { MainContent } from "./MainContent";
import { StartContent } from "./StartContent";

export const Main = () => {
  return (
    <>
      <MainContent />
      <StartContent />
    </>
  );
};
